export function validateHexCode(code: string): boolean {
  // Check if code is exactly 6 characters and contains only valid hex digits
  const hexRegex = /^[0-9A-F]{6}$/;
  return hexRegex.test(code.toUpperCase());
}

export function normalizeHexCode(code: string): string {
  // Remove whitespace and convert to uppercase
  return code.replace(/\s/g, '').toUpperCase();
}

export function compareHexCodes(input: string, stored: string): boolean {
  if (!input || !stored) return false;
  return normalizeHexCode(input) === normalizeHexCode(stored);
}